/**
 * Discount emails append one of these as ?ref= on the walkmore checkout URL.
 * They are not member referral codes. Old links still use ?ref=, so the funnel
 * must ignore them or a return visit gets stored as a fake referral.
 */
const DISCOUNT_LINK_PURPOSES = new Set([
    'checkout_recovery',
    'coaching_nurture',
    'win_back',
    'lead_nurture',
    'access_ending',
]);

export function isDiscountLinkPurpose(value: string | null | undefined): boolean {
    if (!value) return false;
    return DISCOUNT_LINK_PURPOSES.has(value.trim().toLowerCase());
}
